/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 * 
 */

import { Database } from "../database";
/**
 * Connection table ConsultantClient
 */
export class ConsultantClient {
    consultantID: bigint;
    clientID: bigint;

    /**
     * @constructor
     * @param consultantID 
     * @param clientID 
     */
    constructor(consultantID: bigint, clientID: bigint) {
        this.consultantID = consultantID;
        this.clientID = clientID;
    }

    /**
     * @async
     * @function save - Saves the new consultant-client connection
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute sql statement in the database 
     */
    async save(database: Database, accessToken: string): Promise<void> {
        const sql = `INSERT INTO ConsultantClient (clientID, consultantID) VALUES (${this.clientID},${this.consultantID})`;
        console.log(sql);
       await database.readWrite(accessToken, sql);
    }
    
    /**
     * @static
     * @async
     * @function list - List all consultant-client connections
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute sql statement in the database 
     * @returns {Promise<ConsultantClient[]>} Returns a consultant-client array after complete the database process
     */
    static async list(database: Database, accessToken: string): Promise<ConsultantClient[]> {
        const consultantClients: ConsultantClient[] = [];
        if(database){
            const sql = "SELECT * FROM ConsultantClient"
            const rows = await database.read(accessToken, sql);
            rows.forEach((row:any) =>{
                consultantClients.push(new ConsultantClient(row.consultantID, row.clientID));
            })
        }
        return consultantClients;
    }

    /**
     * 
     * @static
     * @async
     * @function delete
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute sql statement in the database 
     * @param {bigint} clientID - The client id which connection with consultant will deleted
     */
    static async delete(database: Database, accessToken: string, clientID: bigint): Promise<void>{
        const sql =
        `DELETE FROM ConsultantClient WHERE clientID=${clientID};`;
      await  database.readWrite(accessToken, sql);
    }

    /**
     * @static
     * @async
     * @function deleteConsultantClients
     * @param {Database} database - Database which is referencing the SQL statement 
     * @param {string} accessToken - Access token to execute sql statement in the database 
     * @param {Array<bigint>} selectedClientIDs - The selected ids which have to be removed
     */
    static async deleteConsultantClients(database:Database, accessToken:string, selectedClientIDs: Array<bigint>): Promise<void>{
        const sql =`DELETE FROM ConsultantClient WHERE clientID IN (${selectedClientIDs.join(",")})`;
        await database.readWrite(accessToken, sql);
    }
}